// extracted by mini-css-extract-plugin
export default {"button":"LockToggle_button__vDYxN","iconWrap":"LockToggle_iconWrap__3I9Iv","icon":"LockToggle_icon__T9Cg3"};